import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AuthService } from 'src/app/services/auth.service';
import { PersonelService } from 'src/app/services/personel.service';
import { DocumentTypeListDto } from 'src/app/models/Personel';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { SpinnermoduleComponent } from 'src/app/spinnermodule/spinnermodule.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';



@Component({
  selector: 'app-pdf-yukle',
  templateUrl: './pdf-yukle.component.html',
  styleUrls: ['./pdf-yukle.component.css']
})
export class PdfYukleComponent implements OnInit {

  turler: DocumentTypeListDto[];
  listMonth: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  listYear: string[] = ["2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027"];
  selectedTur: DocumentTypeListDto;
  selectedMonth: string;
  selectedYear: string;
  pdfFile: File;


  pdfForm = new FormGroup({
    pdf: new FormControl('', [Validators.required]),
    //fileSource: new FormControl('', [Validators.required])
  });


  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    public personelService: PersonelService,
    private spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit() {

    this.personelService.getTypes().subscribe(res => {
      //console.log(res);
      this.turler = res;
    });

  }

  get pdf() {
    return this.pdfForm.controls;
  }

  onFileChange(event) {

    //console.log(event);

    if (event.target.files.length > 0) {
      this.pdfFile = (event.target as HTMLInputElement).files[0];
      /*this.pdfForm.patchValue({
        pdf: file
      });
      this.pdfForm.get('pdf').updateValueAndValidity();*/
      //console.log(this.pdfFile);
    }
  }


  addPdf() {

    if (this.pdfFile.size > 0) {

      const formData = new FormData();
      formData.append('Year', this.selectedYear);
      formData.append('Month', this.selectedMonth);
      formData.append('DocumentTypeId', this.selectedTur.Id.toString());
      formData.append('Pdf', this.pdfFile);

      //console.log(this.pdfFile.arrayBuffer());
      //console.log(formData.get("Pdf").toString());

      //spinner açma
      this.spinner.show();

      this.personelService.sendPdf(formData).subscribe(res => {
        //console.log(res);
        this.spinner.hide();

        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: true,
            text: "Pdf yükleme başarılı.",
            subject: "Pdf Yükleme"
          }
        }).afterClosed().subscribe(() => {
          this.selectedTur = null;
          this.selectedYear = null;
          this.selectedMonth = null;
          this.pdfFile = null;
        });
      },
        error => {
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess: false,
              text: error.error.error,
              subject: "Pdf Yükleme"
            }
          });
        });

      /*
      console.log(this.selectedTur);
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
      console.log(formData);*/
      /*
         const formData = new FormData();
         formData.append('file', this.pdfForm.get('fileSource').value);
         console.log("upload success");
         */
      /*this.http.post('http://localhost:8001/upload.php', formData)
        .subscribe(res => {
          console.log(res);
          alert('Uploaded Successfully.');
        })*/
    } else {
      this.dialog.open(NotifymodalComponent, {
        data: {
          isSuccess: false,
          text: "Pdf eklenemedi. Lütfen tekrar deneyin",
          subject: "Pdf Yükleme",
        }
      });
    }
  }

}
